var a = (t, n, i) => new Promise((p, c) => {
  var r = (e) => {
    try {
      o(i.next(e));
    } catch (s) {
      c(s);
    }
  }, u = (e) => {
    try {
      o(i.throw(e));
    } catch (s) {
      c(s);
    }
  }, o = (e) => e.done ? p(e.value) : Promise.resolve(e.value).then(r, u);
  o((i = i.apply(t, n)).next());
});
import { selfAxios as d } from "@oppein/op-utils";
function k(t) {
  return a(this, null, function* () {
    const {
      data: n
    } = yield d.post(
      "/designapi/design/unifiedCheck/checkByRule",
      t
    );
    return n;
  });
}
export {
  k as postCheckByRule
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designapi/design/unifiedCheck/checkByRule/post.js
// module id = 1762
// module chunks = 41